import { render, staticRenderFns } from "./ProcessTimerSection.vue?vue&type=template&id=319acdbd&scoped=true"
import script from "./ProcessTimerSection.ts?vue&type=script&lang=ts&external"
export * from "./ProcessTimerSection.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessTimerSection.vue?vue&type=style&index=0&id=319acdbd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319acdbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('319acdbd')) {
      api.createRecord('319acdbd', component.options)
    } else {
      api.reload('319acdbd', component.options)
    }
    module.hot.accept("./ProcessTimerSection.vue?vue&type=template&id=319acdbd&scoped=true", function () {
      api.rerender('319acdbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/components/ProcessTimerSection/ProcessTimerSection.vue"
export default component.exports